export default __webpack_public_path__ + "static/media/NoStatus.f975cd5d.svg";